import { render, staticRenderFns } from "./ScrollDownButton.vue?vue&type=template&id=0d1c564a&scoped=true&"
import script from "./ScrollDownButton.vue?vue&type=script&lang=ts&"
export * from "./ScrollDownButton.vue?vue&type=script&lang=ts&"
import style0 from "./ScrollDownButton.vue?vue&type=style&index=0&id=0d1c564a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1c564a",
  null
  
)

export default component.exports